import { services } from '@qompium/pages-helper-tools';
import * as apiClient from './apiClient';
import { User } from '../models';

const userServiceUrl = services.users;

export async function getMe() {
  return await apiClient.get<User>(userServiceUrl, 'me');
}
